import { createSelector } from "reselect";
import { getAvailableTeams } from "~/Redux/AvailableUsers";
import { getAllUsers } from "../users/selectors";
import { emptyMessageFormatter, MessageFormatter } from "./MessageFormatter";

export const getMessageFormatter = createSelector(getAllUsers, getAvailableTeams, (allUsers, allTeams) => {
    if (!allUsers || !allTeams) {
        return emptyMessageFormatter;
    }

    const users = Object.values(allUsers);
    const teams = Object.values(allTeams);

    return new MessageFormatter(users, teams);
});
